import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest } from "services/ServiceUtil";
import { LIBRARY_SERVICE_METHOD } from "services/commonService";

const initialState: any = {
  privacyAndDisclaimer: null,
  PrivacyAndDisclaimerLoader: false
};

const SLICE = "PrivacyAndDisclaimer";

export const fetchPrivacyAndDisclaimer = createAsyncThunk(`${SLICE}/fetchPrivacyAndDisclaimer`, (thunkApi) =>
  apiRequest(LIBRARY_SERVICE_METHOD.getDisclaimerAndPrivacy, {}, thunkApi, ["notes"], {
    type: `franchise_disclaimer,privacy_notice`
  })
);

export const closeDialog = createAction("plans/clearState");

export const PrivacyAndDisclaimer = createSlice({
  name: SLICE,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(fetchPrivacyAndDisclaimer.pending, (state) => {
        state.PrivacyAndDisclaimerLoader = true;
      })
      .addCase(fetchPrivacyAndDisclaimer.fulfilled, (state, action: any) => {
        state.PrivacyAndDisclaimerLoader = false;
        state.privacyAndDisclaimer = action.payload;
      })
      .addCase(fetchPrivacyAndDisclaimer.rejected, (state) => {
        state.PrivacyAndDisclaimerLoader = false;
      });
  }
});

export default PrivacyAndDisclaimer.reducer;
